import React from "react";
import ChatBotComp from "../components/chatbot/ChatBotComp";

export default function Chatbot() {
  return <ChatBotComp />;
}

export async function getStaticProps() {
  const metaTags = {
    title: `Chatbot | Get in Touch with Us Today`,
    description: `Contact us today and let us know how we can assist you. Our team is here to answer any questions you may have.`,
  };

  return {
    props: { metaTags },
  };
}
